<template>
    <div>
        <select ref="input">
            <option v-for="(name, index) of languages"
                    :key="index"
                    :value="index"
                    :selected="data === index">
                {{name}}
            </option>
        </select>
    </div>
</template>

<script>
	import LanguageService from "../../services/LanguageService";

	export default {
		name: "LangPicker",
		props: {
			data: {
				required: true
			}
		},
		data() {
			return {
				languages: LanguageService.getNames()
			}
		},
		methods: {
			getValue() {
				return parseInt(this.$refs.input.value);
			}
		}
	}
</script>

<style scoped>

</style>